import { IEmptyObject } from "@Components/shared/types";
import Result from "@Core/Result";
import { ServiceBase } from "@Core/ServiceBase";
import { IOptionDefinitionDetails, IOptionInstanceDetails } from "@Models/IOptionDefinitionDetails";

export default class OptionService extends ServiceBase {
    public async getSystemDefinitions(): Promise<Result<IOptionDefinitionDetails[]>> {
        return await this.requestJson<IOptionDefinitionDetails[]>({
            url: `/api/Option/GetSystemDefinitions`,
            method: "GET",
        });
    }

    public async getGroupDefinitions(): Promise<Result<IOptionDefinitionDetails[]>> {
        return await this.requestJson<IOptionDefinitionDetails[]>({
            url: `/api/Option/GetGroupDefinitions`,
            method: "GET",
        });
    }

    public async getUserDefinitions(): Promise<Result<IOptionDefinitionDetails[]>> {
        return await this.requestJson<IOptionDefinitionDetails[]>({
            url: `/api/Option/GetUserDefinitions`,
            method: "GET",
        });
    }

    public async getSystem(): Promise<Result<IOptionInstanceDetails[]>> {
        return await this.requestJson<IOptionInstanceDetails[]>({
            url: `/api/Option/GetSystem`,
            method: "GET",
        });
    }

    public async getGroup(groupId: string): Promise<Result<IOptionInstanceDetails[]>> {
        return await this.requestJson<IOptionInstanceDetails[]>({
            url: `/api/Option/GetGroup/${groupId}`,
            method: "GET",
        });
    }

    public async getUser(userId: string): Promise<Result<IOptionInstanceDetails[]>> {
        return await this.requestJson<IOptionInstanceDetails[]>({
            url: `/api/Option/GetUser/${userId}`,
            method: "GET",
        });
    }

    public async updateSystem(data: IOptionInstanceDetails): Promise<Result<IEmptyObject>> {
        return await this.requestJson({
            url: `/api/Option/UpdateSystem`,
            method: "PATCH",
            data,
        });
    }

    public async updateGroup(groupId: string, data: IOptionInstanceDetails): Promise<Result<IEmptyObject>> {
        return await this.requestJson({
            url: `/api/Option/UpdateGroup/${groupId}`,
            method: "PATCH",
            data,
        });
    }

    public async updateUser(userId: string, data: IOptionInstanceDetails): Promise<Result<IEmptyObject>> {
        return await this.requestJson({
            url: `/api/Option/UpdateUser/${userId}`,
            method: "PATCH",
            data,
        });
    }
}
